// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1gySp{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._1gySp .label{color:#5e6e97;font-size:13px;font-weight:500;white-space:nowrap}._1gySp .perPageSelect{height:36px;position:relative;width:66px}._1gySp .select__selected-field{display:-ms-flexbox!important;display:flex!important;height:100%;padding:0;-ms-flex-align:center;align-items:center;background:none;border:none;border-radius:5px;font-size:13px;font-weight:500!important}", ""]);
// Exports
exports.locals = {
	"perPageSelect": "_1gySp"
};
module.exports = exports;
